<template>
    <textarea
        ref="textarea"
        :maxlength="maxlength"
        :value="value"
        v-on:keyup="handleKeyStroke"
        v-on:paste="handleKeyStroke"
        class="form-control"
        :placeholder="placeholder"
    ></textarea>
</template>

<script>
export default {
    name: 'textarea-plus',
    props: {
        placeholder: String,
        value: String,
        maxlength: {
            type: [Number, Boolean],
            required: false,
            default: false
        }
    },
    mounted() {
        this.adjustHeight();
    },
    watch: {
        value() {
            this.$nextTick(() => {
                this.adjustHeight();
            });
        }
    },
    methods: {
        handleKeyStroke(event) {
            this.textareaAdjust(event.target);
            this.$emit('onChange', event.target.value);
        },
        adjustHeight() {
            if (this.$refs.textarea) {
                this.textareaAdjust(this.$refs.textarea);
            }
        },
        textareaAdjust(el) {
            el.style.height = '1px';
            el.style.height = (25 + el.scrollHeight) + 'px';
        }
    }
}
</script>

<style scoped>
textarea {
    resize: vertical;
    overflow: hidden;
}
</style>
